/**
 * Calculates the backoff delay in milliseconds based on the attempt number.
 * Strategy: Exponential backoff with a cap.
 * Formula: min(1000 * 2^attempt, 30000)
 * 
 * @param attempt - The zero-indexed attempt number (0 = first retry, 1 = second, etc.)
 * @returns The delay in milliseconds to wait before the next attempt.
 */
export function computeBackoffDelayMs(attempt: number): number {
    const baseDelay = 1000;
    const maxDelay = 30000;

    // Calculates: 1000 * 2^attempt
    const calculatedDelay = baseDelay * Math.pow(2, attempt);

    // Cap at maxDelay
    return Math.min(calculatedDelay, maxDelay);
}
